import React from 'react';
import { Polyline } from '@react-google-maps/api';
import { useSelector } from 'react-redux';
import {
    visibleAssetsMarkersSelector,
    selectVehicleById
} from '../../../features/assets/assetsSlice';
const tailOptions = {
    strokeColor: '#00008B',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: '#00008B',
    fillOpacity: 0.35,
    clickable: false,
    draggable: false,
    editable: false,
    visible: true,
    radius: 30000,
    paths: [],
    zIndex: 1
};


const TailPath = ({ assetId }) => {
    const vehicle = useSelector(state => selectVehicleById(state, assetId));
    const tail = vehicle?.tail || [];
    const statusMeta = vehicle?.statusMeta || {};
    const visibleAssetMarkers = useSelector(visibleAssetsMarkersSelector);
    const { colorbg } = statusMeta;
    const visible = visibleAssetMarkers.indexOf(assetId) !== -1;
    if (tail && colorbg && visible) {
        let tailPath = [];
        tail.forEach(tailPoint => {
            if (!isNaN(parseFloat(tailPoint.lat)) && !isNaN(parseFloat(tailPoint.lng))) {
                tailPath.push({
                    lat: parseFloat(tailPoint.lat),
                    lng: parseFloat(tailPoint.lng),
                });
            }

        });
        tailPath = tailPath.reverse();

        return (
            <Polyline
                path={tailPath}
                options={{
                    ...tailOptions,
                    paths: tailPath,
                    strokeColor: colorbg,
                    fillColor: colorbg,

                }}
            />
        );
    } else {
        return null;
    }

}

export default React.memo(TailPath);